import { Container } from "react-bootstrap";
import type { UserType } from "@/briefpoint-client";
import FirmUserList from "@/components/Firm/FirmUserList";
import Loading from "@/components/Loading";
import Toggle from "@/components/Toggle";
import { useAuth } from "@/hooks/useAuth";
import useFirm from "@/hooks/useFirm";
import type { FirmClient } from "@/lib/types";

export default function FirmScreen() {
  const { firm, setFirm } = useAuth();
  const [
    users,
    invites,
    refreshUsers,
    sendInvite,
    activateDeactivateUser,
    updatePreferences,
    cancelInvite,
  ] = useFirm(firm?.id);

  async function SubmitInvite(email: string, type: UserType) {
    await sendInvite(email, type);
  }

  async function ActivateDeactivateUser(userId: string, activate: boolean) {
    await activateDeactivateUser(userId, activate);
  }

  async function UpdateAllowBPAccess() {
    const prefs = firm?.preferences ?? {};
    prefs.allowBriefpointAdminAccess = !prefs.allowBriefpointAdminAccess;
    await updatePreferences(prefs);
    setFirm({ ...firm, preferences: prefs } as FirmClient);
  }

  async function HandleFeatureToggle() {
    if (refreshUsers) {
      await refreshUsers();
    }
  }

  return (
    <Container className="page-container">
      <Loading isLoading={users === null}>
        {users ? (
          <FirmUserList
            invites={invites}
            users={users}
            firmId={firm?.id || ""}
            onInvite={SubmitInvite}
            onCancelInvite={cancelInvite}
            onActivateDeactivate={ActivateDeactivateUser}
            onFeatureToggle={HandleFeatureToggle}
          />
        ) : (
          <p>No Users</p>
        )}
        <Toggle
          checked={firm?.preferences?.allowBriefpointAdminAccess ?? false}
          label="Allow Briefpoint staff to access your account for implementation and/or troubleshooting purposes?"
          checkedName="Yes"
          unCheckedName="No"
          onToggle={UpdateAllowBPAccess}
          className="mt-3"
        />
      </Loading>
    </Container>
  );
}
